import { useQuery } from "@tanstack/react-query";
import { getRecordExchangeStats } from "@/api/record-exchange.api";

export const recordExchangeKeys = {
  stats: ["record-exchange", "stats"] as const,
};

/** Poll pending inbox count for the sidebar badge. */
export function useRecordExchangeStats() {
  return useQuery({
    queryKey: recordExchangeKeys.stats,
    queryFn: getRecordExchangeStats,
    refetchInterval: 5 * 60_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus: true,
  });
}

/** Pending record exchange requests - sidebar badge on Record Exchange nav. */
export function useRecordExchangePendingCount(): number {
  const { data } = useRecordExchangeStats();
  return data?.pending ?? 0;
}
